import React from 'react';
import moment from 'moment';
import { Icon, ButtonTooltip } from '../../index';

const TalentColumns = handleAction => [
  {
    name: 'NOMBRE DEL CURSO',
    selector: 'courseName',
    sortable: true,
    grow: 2
  },
  {
    name: 'FECHA DE INICIO',
    selector: 'startDate',
    cell: item => (item.startDate ? moment(item.startDate).format('DD/MM/YYYY') : '-'),
    sortable: true
  },
  {
    name: 'FECHA TERMINO',
    selector: 'endDate',
    cell: item => (item.endDate ? moment(item.endDate).format('DD/MM/YYYY') : '-'),
    sortable: true
  },
  {
    name: 'MODALIDAD',
    selector: 'translatedCourseModality',
    sortable: true
  },
  {
    name: 'COSTO',
    selector: 'parsedCostPerParticipant',
    sortable: true
  },
  {
    name: 'ESTADO',
    selector: 'translatedStatus',
    sortable: true
  },
  {
    name: 'ACCIONES',
    cell: item => (
      <div className="d-flex justify-content-center w-100">
        {item.certificateDocumentId ? (
          <ButtonTooltip
            onClick={() => handleAction(item, 'show')}
            variant="circle-info"
            className="btn-circle"
            size="sm"
            text="Ver Certificado"
          >
            <Icon icon="eye" />
          </ButtonTooltip>
        ) : null}
      </div>
    ),
    center: true,
    ignoreRowClick: true,
    allowOverflow: true,
    button: true
  }
];

export default TalentColumns;
